import type { Component } from 'vue'
import type { RouteRecordRaw } from 'vue-router'

import { DOCTYPES } from '@/constants/doctypes.ts'
import { PERMISSIONS } from '@/constants/permissions.ts'

const routeActivityRadarHome: RouteRecordRaw = {
  component: async (): Promise<Component> => {
    return await import('@/components/views/activities/ActivityRadarView.vue')
  },
  meta: {
    doctypes: {
      [DOCTYPES.CONTACT]: [PERMISSIONS.SELECT, PERMISSIONS.READ], // available in both cases
      [DOCTYPES.CUSTOMER]: [PERMISSIONS.READ],
      [DOCTYPES.EVENT]: [PERMISSIONS.READ],
      [DOCTYPES.SALES_PARTNER]: [PERMISSIONS.READ],
      [DOCTYPES.SUPPLIER]: [PERMISSIONS.READ],
      [DOCTYPES.TW_ACTIVITY_DOCUMENTATION]: [PERMISSIONS.READ],
    },
  },
  name: 'activity-radar-home',
  path: '',
}

const routeActivityRadarRoot: RouteRecordRaw = {
  children: [routeActivityRadarHome],
  path: 'activity-radar',
}

/**
 * Value of the `users` query that opens the radar on everyone's activities. Without it the
 * radar preselects the logged in user.
 */
const ACTIVITY_FEED_ALL_USERS = 'all'

export { ACTIVITY_FEED_ALL_USERS, routeActivityRadarHome, routeActivityRadarRoot }
